/// <reference path="D:\Development\Bayleys\Bayleys Web\src\Bayleys.Web\public\js\jquery-bundle.min.js" />

function loadLocaleOptions(elId, data, defaultOpt, clearAll) {
    var options = $('#' + elId + ' option');
    var count = options.length;
    if (count > 1 || clearAll === true)
        for (var i = clearAll === true ? 0 : 1; i < count; i++) {
            $(options[i]).remove();
        }

    $.each(data, function(index, value) {
        $('#' + elId).append($('<option value="' + this.Id + '">' + this.Name + '</option>'));
    });

    $('#' + elId).val(defaultOpt);
}

function abbrNum(number, decPlaces) {
    decPlaces = Math.pow(10,decPlaces);
    var abbrev = [ "k", "m", "b", "t" ];
    for (var i=abbrev.length-1; i>=0; i--) {
        var size = Math.pow(10,(i+1)*3);
        if(size <= number) {
             number = Math.round(number*decPlaces/size)/decPlaces;
             number += abbrev[i];
             break;
        }
    }
    return number;
}

function RememberPropertyTypeOptions() {
    var selectedOptions = $('[name="propertyTypesSelect"]:not([disabled]) > option:selected').map(function() {
        return $.map($(this).data(), function(v) {
            return v;
        });
    }).get();

    $('[name="propertyTypesSelect"] option').each(function () {
        $(this).attr('data-bitwise',$(this).val() + '-' + $(this).html().replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-') );
    });

    $('[name="propertyTypesSelect"] option').each(function () {
        if ($.inArray($(this).data('bitwise'), selectedOptions) !== -1) {
            $(this).prop('selected', true);
        }
    });
    
    $('[name="propertyTypesSelect"]').multiselect('rebuild');
}

function loadPropertyTypeOptions(url) {
    $.get(
        url,
        function(data) {
            var options = $('[name="propertyTypesSelect"] option'),
            selectedOptions = $('[name="propertyTypesSelect"]:not([disabled]) > option:selected').map(function() {
                return $.map($(this).data(), function(v) {
                    return v;
                });
            }).get(),
            count = options.length;
            if (count > 0)
                for (var i = 0; i < count; i++) {
                    $(options[i]).remove();
                }

            $.each(data, function(index, value) {
                $('[name="propertyTypesSelect"]').append($('<option value="' + this.Bitwise + '"' + 'data-bitwise="' + this.Bitwise + '-' + this.Description.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-') + '">' + this.Description + '</option>'));
            });

            $('[name="propertyTypesSelect"] option').each(function () {
                if ($.inArray($(this).data('bitwise'), selectedOptions) !== -1) {
                    $(this).prop('selected', true);
                }
            });
           
            $('[name="propertyTypesSelect"]').multiselect('rebuild');
        });
}

function disableElement(elId) {
    var el = $('#' + elId);
    $(el).addClass('hide');
    $(el).find('input, select').attr('disabled', 'disabled');
    $(el).find('select').not('.no-reset').multiselect('rebuild');
}

function enableElement(elId) {
    var el = $('#' + elId);
    $(el).removeClass('hide');
    $(el).find('input, select').removeAttr('disabled');
    $(el).find('select').not('.no-reset').multiselect('rebuild');
}

function searchTypeMultiSelect() {
    $('#searchType').multiselect({
        buttonContainer: '<div class="btn-group btn-block"></div>',
        buttonClass: 'btn btn-default btn-lg btn-block',
        templates: {
            button: '<button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown" tabindex="2" accesskey="t"><span class="multiselect-selected-text"></span> <b class="caret"></b></button>',
            ul: '<ul class="multiselect-container dropdown-menu megamenu-fw btn-block"></ul>'
        },
        onChange: function(element, checked) {
            loadSearchType();
        }
    });
}

function doubleRangeSlider(elements) {
    $(elements).each(function() {
        var $this = $(this),
            minRange = $this.find('.min-select'),
            btnGroup = $this.find('.btn-group.hide'),
            fieldLabel = $this.find('.text-muted.hide'),
            rangeTarget = $this.find('.range-slider-target'),
            rangeLabel = $this.data('label'),
            rangeAny = $this.data('any'),
            rangePrefix = $this.data('prefix'),
            rangeIcon = $this.data('icon'),
            rangePostfix = $this.data('postfix'),
            rangeMultiple = $this.data('multiple'),
            rangeInterval = $this.data('interval'),
            minSelected = minRange.find('option:selected').index(),
            allMaxOptions = minRange.children('option').length,
            maxRange = $this.find('.max-select'),
            maxSelected = maxRange.find('option:selected').index(),
            allValues = [];

        minRange.find('option').each(function() {
            allValues.push($(this).val());
        }).promise().done(function() {
            allValues.push('');
        });
        if (minSelected !== 0 || maxSelected !== 0) {
            $('.search-options').find('.' + rangeIcon).removeClass('hide');
        }
        if (maxSelected === 0 || maxSelected === '') {
            maxSelected = allMaxOptions;
        }
        if (!(browser.isIe() && browser.getVersion() <= 9)) {
            $(rangeTarget).ionRangeSlider({
                type: 'double',
                from: minSelected,
                to: maxSelected,
                grid: true,
                keyboard: true,
                values: allValues,
                prefix: '<span class="slider-label">' + rangeLabel + '</span>',
                prettify: function(num) {
                    if (num === 0) {
                        return '<span class="slider-any">Any </span><span class="only-on-any">' +
                            rangeAny +
                            '</span>' +
                            '<span class="only-on-slider">' +
                            rangeMultiple +
                            '</span>';
                    } else if (num === 1) {
                        return '<span class="slider-prefix">' +
                            rangePrefix +
                            '</span>' +
                            '<span class="slider-value">' +
                            num +
                            '</span>' +
                            '<span class="only-on-slider">' +
                            rangePostfix +
                            '</span>';
                    } else if (num > 1 & rangePrefix === "$") {
                        return '<span class="slider-prefix">' +
                            rangePrefix +
                            '</span>' +
                            '<span class="slider-value only-on-grid">' +
                            abbrNum(num, 1) +
                            '</span>' +
                            '<span class="only-on-slider">' +
                            num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
                            '</span>' +
                            '<span class="only-on-slider">' +
                            rangePostfix +
                            '</span>' +
                            '<span class="only-on-slider">' +
                            rangeMultiple +
                            '</span>';
                    } else {
                        return '<span class="slider-prefix">' +
                            rangePrefix +
                            '</span>' +
                            '<span class="slider-value">' +
                            num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
                            '</span>' +
                            '<span class="only-on-slider">' +
                            rangePostfix +
                            '</span>' +
                            '<span class="only-on-slider">' +
                            rangeMultiple +
                            '</span>';
                    }
                },
                onChange: function(num) {
                    if (num.from_percent !== 0 || num.to_percent !== 100) {
                        $('.search-options').find('.' + rangeIcon).removeClass('hide');
                    } else {
                        $('.search-options').find('.' + rangeIcon).addClass('hide');
                    }
                    $(minRange).val(num.from_value);
                    $(maxRange).val(num.to_value);
                },
                values_separator: ' to ',
                min_interval: rangeInterval,
                force_edges: true
            });
        }
        else {
            $(rangeTarget).addClass('hide');
            $(btnGroup).removeClass('hide');
            $(fieldLabel).removeClass('hide');
            $('.min-select, .max-select').multiselect();
        }
    });
}

function singleRangeSlider(elements) {
    $(elements).each(function() {
        var $this = $(this),
        minRange = $this.find('.min-select'),
        rangeTarget = $this.find('.range-slider-target'),
        btnGroup = $this.find('.btn-group.hide'),
        fieldLabel = $this.find('.text-muted.hide'),
        rangeLabel = $this.data('label'),
        rangeAny = $this.data('any'),
        rangePrefix = $this.data('prefix'),
        rangeIcon = $this.data('icon'),
        rangePostfix = $this.data('postfix'),
        rangeMultiple = $this.data('multiple'),
        minSelected = minRange.find('option:selected').index(),
        minSelectedVal = minRange.find('option:selected').val(),
        allMaxOptions = minRange.children('option').length,
        allValues = [];
        minRange.find('option').each(function() {
            allValues.push($(this).val());
        });
        if (minSelected === 0 || minSelected === '') {
            $('.search-options').find('.' + rangeIcon).addClass('hide');
        }
        else {
            $('.search-options').find('.' + rangeIcon).removeClass('hide');
        }
        if (!(browser.isIe() && browser.getVersion() <= 9)) {
            $(rangeTarget).ionRangeSlider({
                type: 'single',
                from: minSelected,
                grid: true,
                keyboard: true,
                values: allValues,
                // skin: "round",
                prefix: '<span class="slider-label">' + rangeLabel + '</span>',
                prettify: function(num) {
                    if (num === 0) {
                        return '<span class="slider-any">Any </span><span class="only-on-any">' +
                            rangeAny +
                            '</span>' +
                            '<span class="only-on-slider">' +
                            rangeMultiple +
                            '</span>';
                    } else if (num === 1) {
                        return '<span class="slider-prefix">' +
                            rangePrefix +
                            '</span>' +
                            '<span class="slider-value">' +
                            num +
                            '+</span>' +
                            '<span class="only-on-slider">' +
                            rangePostfix +
                            '</span>';
                    } else {
                        return '<span class="slider-prefix">' +
                            rangePrefix +
                            '</span>' +
                            '<span class="slider-value">' +
                            num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
                            '+</span>' +
                            '<span class="only-on-slider">' +
                            rangePostfix +
                            '</span>' +
                            '<span class="only-on-slider">' +
                            rangeMultiple +
                            '</span>';
                    }
                },
                onChange: function(num) {
                    if (num.from_percent === 0) {
                        $('.search-options').find('.' + rangeIcon).addClass('hide');
                    } else {
                        $('.search-options').find('.' + rangeIcon).removeClass('hide');
                    }
                    $(minRange).val(num.from_value);
                },
                force_edges: true
            });
        }
        else {
            $(rangeTarget).addClass('hide');
            $(btnGroup).removeClass('hide');
            $(fieldLabel).removeClass('hide');
            $('.min-select').multiselect();
        }
    });
}

function showHidePrices() {
    var searchType = $('#searchType').val();
    var listingType = $('input[name="listingType"]:checked').val();
    if ((searchType === 'Residential') && (listingType === 'Rent' || listingType === 'Rental' || listingType === 'RentalLease')) {
        disableElement('price');
        disableElement('leasePrice');
        enableElement('rentalPrice');
        disableElement('ifEverything');
        $('.search-options .listing-type').text(' for rent ');
    } else if (searchType === 'Commercial' && (listingType === 'Lease' || listingType === 'Rent' || listingType === 'Rental' || listingType === 'RentalLease')) {
        disableElement('price');
        disableElement('rentalPrice');
        enableElement('leasePrice');
        disableElement('ifEverything');
        disableElement('investmentTypes');
        $('.search-options .listing-type').text(' for lease ');
        $('#otherParking').removeClass('col-md-offset-3');
        loadPropertyTypeOptions('/property-types/commercial/lease');
    } else if ((searchType === 'Residential' || searchType === 'Commercial' || searchType === 'Lifestyle' || searchType === 'Business' || searchType === 'Rural') && (listingType === 'Sale' || listingType === 'None')) {
        disableElement('leasePrice');
        disableElement('rentalPrice');
        enableElement('price');
        disableElement('ifEverything');
        $('.search-options .listing-type').text('');
        $('#otherParking').addClass('col-md-offset-3');
        if (searchType === 'Commercial') {
            enableElement('investmentTypes');
            loadPropertyTypeOptions('/property-types/commercial');
        }
    } else if (searchType === 'Everything'){
        disableElement('leasePrice');
        disableElement('rentalPrice');
        disableElement('price');
        enableElement('ifEverything');
        $('.search-options .listing-type').text('');
    }
}

function configureEverything() {
    $('#rentLeaseSpan').text('Rent/Lease');
    disableElement('listingTypes');
    disableElement('beds');
    disableElement('bathrooms');
    disableElement('residentialParking');
    disableElement('otherParking');
    disableElement('lifestyleLandAreaHectares');
    disableElement('ruralLandAreaHectares');
    disableElement('landAreaSquareMetres');
    disableElement('floorAreaSquareMetres');
    disableElement('propertyTypesContainer');
    disableElement('investmentTypes');
    disableElement('businessGroups');
    disableElement('propertyTypesContainerCommercial');
    loadPropertyTypeOptions('/property-types');
}

function configureResidential() {
    $('.search-options .search-type').text(' in residential ');
    $('#rentLeaseSpan').text('Rental');    
    $('#lt3').val('Rental');
    enableElement('listingTypes');
    enableElement('beds');
    enableElement('bathrooms');
    enableElement('residentialParking');
    enableElement('propertyTypesContainer');
    disableElement('lifestyleLandAreaHectares');
    disableElement('ruralLandAreaHectares');
    disableElement('landAreaSquareMetres');
    disableElement('floorAreaSquareMetres');
    disableElement('businessGroups');
    disableElement('investmentTypes');
    disableElement('propertyTypesContainerCommercial');
    disableElement('otherParking');
    loadPropertyTypeOptions('/property-types/residential');
    $('#price').removeClass('col-lg-offset-2');
}

function configureLifestyle() {
    $('.search-options .search-type').text(' in lifestyle ');
    enableElement('beds');
    enableElement('bathrooms');
    enableElement('lifestyleLandAreaHectares');
    enableElement('propertyTypesContainer');
    enableElement('price');
    disableElement('rentalPrice');
    disableElement('leasePrice');
    disableElement('listingTypes');
    disableElement('landAreaSquareMetres');
    disableElement('ruralLandAreaHectares');
    disableElement('floorAreaSquareMetres');
    disableElement('residentialParking');
    disableElement('businessGroups');
    disableElement('investmentTypes');
    disableElement('propertyTypesContainerCommercial');
    disableElement('otherParking');
    loadPropertyTypeOptions('/property-types/residential');
    $('#price').removeClass('col-lg-offset-2');
}

function configureRural() {
    $('.search-options .search-type').text(' in rural ');
    enableElement('beds');
    enableElement('bathrooms');
    enableElement('ruralLandAreaHectares');
    enableElement('propertyTypesContainer');
    enableElement('price');
    disableElement('rentalPrice');
    disableElement('leasePrice');
    disableElement('listingTypes');
    disableElement('lifestyleLandAreaHectares');
    disableElement('landAreaSquareMetres');
    disableElement('floorAreaSquareMetres');
    disableElement('residentialParking');
    disableElement('businessGroups');
    disableElement('investmentTypes');
    disableElement('propertyTypesContainerCommercial');
    disableElement('otherParking');
    loadPropertyTypeOptions('/property-types/rural');
    $('#price').removeClass('col-lg-offset-2');
}

function configureCommercial() {
    $('.search-options .search-type').text(' in commercial ');
    $('#rentLeaseSpan').text('Lease');
    $('#lt3').val('Lease');
    enableElement('listingTypes');
    enableElement('propertyTypesContainerCommercial');
    enableElement('floorAreaSquareMetres');
    enableElement('landAreaSquareMetres');
    enableElement('investmentTypes');
    enableElement('otherParking');
    disableElement('beds');
    disableElement('bathrooms');
    disableElement('lifestyleLandAreaHectares');
    disableElement('ruralLandAreaHectares');
    disableElement('residentialParking');
    disableElement('businessGroups');
    disableElement('propertyTypesContainer');
    var listingTypeCommercial = $('input[name="listingType"]:checked').val();
    if ( listingTypeCommercial === 'Lease' ) {
        loadPropertyTypeOptions('/property-types/commercial/lease');
    }
    else {
        loadPropertyTypeOptions('/property-types/commercial');
    }
    $('#price').addClass('col-lg-offset-2');
}

function configureBusiness() {
    $('.search-options .search-type').text(' in business ');
    disableElement('listingTypes');
    disableElement('lifestyleLandAreaHectares');
    disableElement('ruralLandAreaHectares');
    disableElement('floorAreaSquareMetres');
    disableElement('landAreaSquareMetres');
    disableElement('beds');
    disableElement('bathrooms');
    disableElement('residentialParking');
    disableElement('propertyTypesContainer');
    disableElement('investmentTypes');
    disableElement('propertyTypesContainerCommercial');
    disableElement('rentalPrice');
    disableElement('leasePrice');
    enableElement('businessGroups');
    enableElement('price');
    enableElement('otherParking');
    loadPropertyTypeOptions('/property-types/business');
    $('#price').addClass('col-lg-offset-2');
}

function loadSearchType() {
    var value = $('select#searchType').val();
    $('#searchOptions').removeClass('Residential')
        .removeClass('Lifestyle')
        .removeClass('Rural')
        .removeClass('Commercial')
        .removeClass('Business')
        .removeClass('Everything')
        .addClass(value);
    switch (value) {
        case 'Residential':
            configureResidential();
            break;
        case 'Lifestyle':
            configureLifestyle();
            break;
        case 'Rural':
            configureRural();
            break;
        case 'Commercial':
            configureCommercial();
            break;
        case 'Business':
            configureBusiness();
            break;
        default:
            configureEverything();
            break;
    }
    showHidePrices();
}

function toggleSearchOptionsButton() {
    $('#search-filtering-options').on('hide.bs.collapse', function () {
        $('#search-options-btn').removeClass('active');
    });
    $('#search-filtering-options').on('show.bs.collapse', function () {
        $('#search-options-btn').addClass('active');
    });
}

$(document).click(function (event) {
    var clickover = $(event.target);
    var $navbar = $('#search-filtering-options');               
    var _opened = $navbar.hasClass('in');
    if (_opened === true && !clickover.isChildOf('.responsive-search')) {      
        $navbar.collapse('hide');
    }
});

function regionIdMultiselect() {
    $('#regionId').multiselect({
        maxHeight: 300,
        buttonContainer: '<div class="btn-group megamenu btn-block" translate="no"></div>',
        buttonClass: 'btn btn-sm btn-default btn-outline',
        buttonWidth: '100%',
        disableIfEmpty: true,
        enableFiltering: true,
        enableCaseInsensitiveFiltering: true,
        templates: {
            ul: '<ul class="multiselect-container dropdown-menu megamenu-fw btn-block" translate="no"></ul>',
            filter: '<li class="multiselect-item multiselect-filter"><div class="input-group"><input class="form-control multiselect-search" type="text" autocomplete="off" spellcheck="false"/></div></li>',
            filterClearBtn: '<span class="input-group-btn"><button class="btn btn-info btn-outline multiselect-clear-filter" type="button" data-toggle="tooltip" title="Clear filters" data-position="top" data-container="body"><svg class="svg svg-icon-close"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-close"></use></svg></button></span>',
        },
        filterPlaceholder: 'Filter regions',
        onChange: function(element, checked) {
            var regionId = $('#regionId').val();
            if (checked === true && regionId !== '') {
                $('.search-options .location').removeClass('hide');
                $.get(
                    '/locales/districts/' + regionId,
                    function(districts, status) {
                        loadLocaleOptions('districtId', districts, '', false);
                        loadLocaleOptions('suburbIds', [], 'All Suburbs', true);
                        $('#districtId, #suburbIds').multiselect('deselectAll', true).multiselect('rebuild');
                    });
            } else if (checked === false || regionId === '') {
                $('.search-options .location').addClass('hide');
                loadLocaleOptions('districtId', [], '', true);
                loadLocaleOptions('suburbIds', [], 'All Suburbs', true);
                $('#districtId, #suburbIds').multiselect('deselectAll', true).multiselect('rebuild');
            }
        },
        onInitialized: function(select, container) {
            var regionId = $('#regionId').val();
            if (regionId !== 0 && regionId !== '') {
                $('.search-options .location').removeClass('hide');
            }
        }
    });
}

function districtIdMultiselect() {
    var numberDistricts = $('#districtId option').size();

    $('#districtId').multiselect({
        maxHeight: 300,
        buttonContainer: '<div class="btn-group megamenu btn-block" translate="no"></div>',
        buttonClass: 'btn btn-sm btn-default btn-outline',
        buttonWidth: '100%',
        disableIfEmpty: true,
        disabledText: 'All areas',
        nonSelectedText: 'Select an area',
        enableFiltering: true,
        enableCaseInsensitiveFiltering: true,
        templates: {
            ul: '<ul class="multiselect-container dropdown-menu megamenu-fw btn-block" translate="no"></ul>',
            filter: '<li class="multiselect-item multiselect-filter"><div class="input-group"><input class="form-control multiselect-search" type="text" autocomplete="off" spellcheck="false"/></div></li>',
            filterClearBtn: '<span class="input-group-btn"><button class="btn btn-info btn-outline multiselect-clear-filter" type="button" data-toggle="tooltip" title="Clear filters" data-position="top" data-container="body"><svg class="svg svg-icon-close"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-close"></use></svg></button></span>',
        },
        filterPlaceholder: 'Filter areas',
        onChange: function(element, checked) {
            var districtId = $('#districtId').val();
            if (checked === true && districtId !== '') {
                $('.search-options .location').removeClass('hide');
                $.get(
                    '/locales/suburbs/' + districtId,
                    function(suburbs, status) {
                        loadLocaleOptions('suburbIds', suburbs, 'All Suburbs', true);
                        $('#suburbIds').multiselect('deselectAll', true).multiselect('rebuild').multiselect('enable');
                    });
            } else {
                $('#suburbIds').multiselect('deselectAll', false).multiselect('rebuild').multiselect('disable');
            }
        },
    });

    if (numberDistricts <= 1) {
        $('#districtId').multiselect('disable');
    }
}

function suburbIdMultiselect() {
    $('#suburbIds').multiselect({
        maxHeight: 300,
        buttonContainer: '<div class="btn-group megamenu btn-block" translate="no"></div>',
        buttonClass: 'btn btn-sm btn-default btn-outline',
        buttonWidth: '100%',
        disableIfEmpty: true,
        disabledText: 'All suburbs',
        allSelectedText: 'All suburbs selected',
        nonSelectedText: 'Select a suburb',
        enableFiltering: true,
        enableCaseInsensitiveFiltering: true,
        includeSelectAllOption: true,
        selectAllText: 'All suburbs',
        templates: {
            ul: '<ul class="multiselect-container dropdown-menu megamenu-fw btn-block" translate="no"></ul>',
            filter: '<li class="multiselect-item multiselect-filter"><div class="input-group"><input class="form-control multiselect-search" type="text" autocomplete="off" spellcheck="false"/></div></li>',
            filterClearBtn: '<span class="input-group-btn"><button class="btn btn-info btn-outline multiselect-clear-filter" type="button" data-toggle="tooltip" title="Clear filters" data-position="top" data-container="body"><svg class="svg svg-icon-close"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-close"></use></svg></button></span>',
        },
        filterPlaceholder: 'Filter suburbs'
    });
}

function packageIdMultiselect() {
    $('#packageIds').multiselect({
        maxHeight: 300,
        buttonContainer: '<div class="btn-group megamenu btn-block"></div>',
        buttonClass: 'btn btn-sm btn-default btn-outline',
        buttonWidth: '100%',
        disableIfEmpty: true,
        enableFiltering: true,
        enableCaseInsensitiveFiltering: true,
        templates: {
            ul: '<ul class="multiselect-container dropdown-menu megamenu-fw btn-block" translate="no"></ul>',
            filter: '<li class="multiselect-item multiselect-filter"><div class="input-group"><input class="form-control multiselect-search" type="text" autocomplete="off" spellcheck="false"/></div></li>',
            filterClearBtn: '<span class="input-group-btn"><button class="btn btn-info btn-outline multiselect-clear-filter" type="button" data-toggle="tooltip" title="Clear filters" data-position="top" data-container="body"><svg class="svg svg-icon-close"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-close"></use></svg></button></span>',
        },
        filterPlaceholder: 'Filter packages'
    });
}

function investmentTypeIdMultiselect() {
    $('#investmentTypeIds').multiselect({
        maxHeight: 300,
        buttonContainer: '<div class="btn-group megamenu btn-block" translate="no"></div>',
        buttonClass: 'btn btn-sm btn-default btn-outline',
        buttonWidth: '100%',
        disableIfEmpty: true,
        disabledText: 'All investment types',
        allSelectedText: 'All investment types selected',
        nonSelectedText: 'Select an investment type',
        templates: {
            ul: '<ul class="multiselect-container dropdown-menu megamenu-fw btn-block" translate="no"></ul>',
        }
    });
}

function listingTypeRadioGroup() {
    $('#listingTypes .btn').click(function(e) {
        var listingTypes = $('#listingTypes');
        listingTypes.children('input[type="radio"]').prop('checked', false);
        $(this).children('input[type="radio"]').prop('checked', true);
        showHidePrices();
    });
}

function businessGroupIdMultiselect() {
    $('#businessGroupIds').multiselect({
        buttonClass: 'btn btn-sm btn-default btn-outline btn-block',
        buttonWidth: '100%',
        templates: {
            ul: '<ul class="multiselect-container dropdown-menu megamenu-fw btn-block"></ul>'
        },
        onChange: function(element, checked) {
            if (checked === true) {
                $('.search-options .business').removeClass('hide');
                loadPropertyTypeOptions('/property-types/business/' + $(element).val());
            } else if (checked === false) {
                $('.search-options .business').addClass('hide');
                loadPropertyTypeOptions('/property-types/business');
            }
        }
    });
}

function propertyTypeMultiselect() {
    $('[name="propertyTypesSelect"]').multiselect({
        maxHeight: 300,
        buttonContainer: '<div class="btn-group megamenu btn-block"></div>',
        buttonClass: 'btn btn-sm btn-default btn-outline',
        buttonWidth: '100%',
        enableFiltering: true,
        enableCaseInsensitiveFiltering: true,
        templates: {
            ul: '<ul class="multiselect-container dropdown-menu megamenu-fw btn-block"></ul>',
            filter: '<li class="multiselect-item multiselect-filter"><div class="input-group"><input class="form-control multiselect-search" type="text" autocomplete="off" spellcheck="false"/></div></li>',
            filterClearBtn: '<span class="input-group-btn"><button class="btn btn-info btn-outline multiselect-clear-filter" type="button" data-toggle="tooltip" title="Clear filters" data-position="top" data-container="body"><svg class="svg svg-icon-close"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-close"></use></svg></button></span>',
        },
        filterPlaceholder: 'Filter listing types',
        numberDisplayed: 6,
        allSelectedText: 'All property types',
        onChange: function(element, checked) {
            if (checked === true) {
                $('.search-options .property-type').removeClass('hide');
            } else if (checked === false) {
                $('.search-options .property-type').addClass('hide');
            }
        },
        onInitialized: function(select, container) {
            if ($('#propertyTypes').val() !== null && $('#propertyTypes').val().length > 0) {
                $('.search-options .property-type').removeClass('hide');
            }
        }
    });

    $('[name="propertyTypesSelect"]').change(function(e) {
        var selectedPropertyTypes = $(this).children('option:selected');
        var bitwise = 0;
        for (var i = 0; i < selectedPropertyTypes.length; i++) {
            bitwise += parseFloat($(selectedPropertyTypes[i]).val());
        }
        if (bitwise === 0) {
            $('#propertyTypes').val('');
        } else {
            $('#propertyTypes').val(bitwise);
        }
    });
}

function sortOrderDropdown() {
    $('#sortOrder').change(function() {
        $('#orderType').val($(this).val());
        $('form#newSearchForm').submit();
    });
}

function setSearchType() {
    var selectedSearchTypeCookie = Cookies.get('selectedSearchType');
    if (selectedSearchTypeCookie !== undefined && selectedSearchTypeCookie !== 'Residential') {
        $('[name="searchType"]').multiselect('select', selectedSearchTypeCookie).multiselect('rebuild');
        loadSearchType();
    }
}

function onSubmitSearch() {
    $('#searchForm, #newSearchForm').on('submit', function(event) {
        var selectedSearchType = $('[name="searchType"]').val();
        Cookies.set('selectedSearchType', selectedSearchType, { expires: 365 });
        if ($(this).hasClass('reporting-search')) {
            if ($(this).data('tabletorefresh')) {
                $('#' + $(this).data('tabletorefresh')).bootstrapTable('refresh');
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: $(".result-details-container").offset().top
                }, 2000);
                return false;
            }
        }
        $('[name="propertyTypesSelect"]').attr('disabled', 'disabled');
        $(this).find('input, select').each(function() {
            var $this = $(this);
            var attr = $this.attr('disabled');
            if (typeof attr === typeof undefined || attr === false) {
                if (!$this.is(':visible') && !$this.is(':hidden')) {
                    $this.attr('disabled', 'disabled');
                } else if (($this.val() === null || ($this.val() !== null && $this.val().length === 0))) {
                    $this.attr('disabled', 'disabled');
                }
            }
        });
    });
}

function initializeSearch() {
    var $searchForm = $('#newSearchForm, #searchForm');
    if ($searchForm.length > 0) {
        // Multiselect dropdowns
        //SearchType (Residential, Commercial, etc.)
        searchTypeMultiSelect();
        // Location multiselects
        regionIdMultiselect();
        districtIdMultiselect();
        suburbIdMultiselect();
        // Listing subtypes (Apartment, house, etc.)
        propertyTypeMultiselect();
        investmentTypeIdMultiselect(); // Filter subtypes for Commercial
        businessGroupIdMultiselect(); // Filter subtypes for Business
        // Package IDs (Total Property, Magazine, etc.)
        packageIdMultiselect();

        // ListingTypes radio group (Buy, rent, etc.)
        listingTypeRadioGroup(); // Check for checked
        RememberPropertyTypeOptions();
        showHidePrices();
        // Range sliders
        doubleRangeSlider('.double-range-slider');
        singleRangeSlider('.single-range-slider');

        // Toggle active/inactive state of button for collapse
        toggleSearchOptionsButton();

        // Dropdown for Sorting (Featured first, Price, etc)
        sortOrderDropdown();

        // Set search type from a Cookie
        setSearchType();

        // Actions on form submission
        onSubmitSearch();
    }
}